import styled from 'styled-components';
import vehicleRotationImage from '../../assets/images/vehicle_rotation.png';

const StyledImg = styled.img.attrs({ src: vehicleRotationImage })`
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	transform: scale(0.75);
	opacity: 0.75;
	-webkit-user-drag: none;
	user-select: none;
	pointer-events: none;
`;

export { StyledImg };
